<template>
  <div
    class="flex flex-col min-h-dvh"
    :class="route.meta?.layoutClasses"
  >
    <Banners />

    <header
      :class="[
        'bg-white border-b border-gray-200 transition-[top,opacity] duration-200 ease-in-out',
        computedPositionClass,
        {
          'max-lg:-top-full max-lg:opacity-0 lg:top-0': isHeaderHidden,
          'top-0 max-lg:opacity-100': !isHeaderHidden,
        },
      ]"
    >
      <nav class="relative hidden lg:flex h-20 mx-auto items-center justify-between gap-x-4 px-4">
        <AppHeaderDesktopHost v-if="isHostMode" />
        <AppHeaderDesktopGuest v-else />
      </nav>

      <div
        v-if="isHeaderSearchFormInHeader && !isHostMode"
        class="flex lg:hidden items-center gap-x-2 p-2 transition-all duration-300 ease-in-out"
      >
        <SearchFormMobileTrigger
          :is-campgrounds="isRenderedCampgroundSearchPage"
          :has-rental-type="!isRenderedRvSearchPage"
          class="flex-1 min-w-0"
        />
      </div>

      <SearchFilters v-if="isRenderedRvSearchPage" />
    </header>

    <slot />

    <AppFooter
      v-if="!route.meta.hideFooter"
      :variant="computedFooterVariant"
      :size="isSearchPage ? 'full' : undefined"
      :is-sticky="isSearchPage"
      :class="[
        'mt-auto',
        {
          'hidden lg:block': mobileSearchMapShown,
          'max-lg:mb-29': isRenderedRequestToBookPage || isRenderedRvRentalPage,
        }]"
    />

    <header
      v-if="!route.meta.hideNavigation && !isRenderedRequestToBookPage && !isRenderedRvRentalPage && !route.meta.hideMobileNavigation"
      :class="[
        'lg:hidden bg-white sticky bottom-0 z-50 pb-safe',
        {
          hidden: mobileSearchMapShown,
        },
      ]"
    >
      <nav class="mx-auto flex items-center justify-evenly gap-x-2 border-t border-gray-200">
        <AppHeaderMobileHost v-if="isHostMode" />
        <AppHeaderMobileGuest v-else />
      </nav>
    </header>
  </div>
</template>

<script setup lang="ts">
const { isRenderedReferralPage, isRenderedRvSearchPage, isHostMode, isRenderedHomePage, isRenderedRequestToBookFlow, isRenderedRequestToBookPage, isRenderedRvRentalPage, isRenderedCampgroundSearchPage } = useBaseName()
const route = useRoute()

const showSearchMapMobile = useShowSearchMapMobile()

const mobileSearchMapShown = computed(() => isRenderedRvSearchPage.value && showSearchMapMobile.value)

const { hydrationStatus } = useHydrationState()

const stickyHeaderSearchFormShown = useStickyHeaderSearchFormShown()
const { isHeaderSearchFormInHeader } = useHeaderSearchFormVisibility()
const showLandingPageSearchForm = computed(() => {
  return isRenderedHomePage.value
})

const isSearchPage = computed(() => {
  return isRenderedRvSearchPage.value || isRenderedCampgroundSearchPage.value
})

const computedPositionClass = computed(() => {
  if (route.meta?.staticHeader) {
    return 'static'
  }

  if (isRenderedHomePage.value) {
    return 'max-lg:fixed w-full sticky z-30'
  }

  return 'sticky z-30'
})

const isHeaderHidden = computed(() => {
  if (isSearchPage.value) {
    return false
  }

  return !hydrationStatus.value || (showLandingPageSearchForm.value && !stickyHeaderSearchFormShown.value)
})

const computedFooterVariant = computed(() => {
  if (isRenderedRequestToBookFlow.value || isRenderedReferralPage.value) {
    return 'compact'
  }

  if (isSearchPage.value) {
    return 'expandable'
  }

  return route.meta?.footerVariant
})

await useScripts()
</script>
